import "./banner.scss";

function Banner() {
  return (
    <div className="banner">
      <div className="banner__container">
        <span className="banner__text">
          A man can't have enough basement swag —
        </span>
        <span className="banner__text">
          A man can't have enough basement swag —
        </span>
        <span className="banner__text">
          A man can't have enough basement swag —
        </span>
      </div>
      <div className="banner__container" aria-hidden="true">
        <span className="banner__text">
          A man can't have enough basement swag —
        </span>
        <span className="banner__text">
          A man can't have enough basement swag —
        </span>
        <span className="banner__text">
          A man can't have enough basement swag —
        </span>
      </div>
    </div>
  );
}

export default Banner;
